import { useCallback, useEffect, useState } from 'react';
import { SaveAdminChangelogItemAPI } from '../../../../api/AdminAPI';

const EMPTY_FORM = {
  slug: '', type: 'improvement', title: '', summary: '', area: '', link: '', cta: '', plan: '',
  highlight: false, item_date: '', internal_note: '', image_media_id: null,
};

const formFromItem = (item) => ({
  slug: item.slug || '',
  type: item.type || 'improvement',
  title: item.title || '',
  summary: item.summary || '',
  area: item.area || '',
  link: item.link || '',
  cta: item.cta || '',
  plan: item.plan || '',
  highlight: Boolean(Number(item.highlight)),
  item_date: item.item_date ? String(item.item_date).slice(0, 10) : '',
  internal_note: item.internal_note || '',
  image_media_id: item.image?.id ?? null,
});

// Campos vazios vão como null (a API grava NULL nas colunas opcionais)
const bodyFromForm = (form, item) => {
  const link = form.link.trim();
  const body = {
    type: form.type,
    title: form.title.trim(),
    summary: form.summary.trim(),
    area: form.area || null,
    link: link || null,
    cta: link ? (form.cta.trim() || null) : null,
    plan: form.plan || null,
    highlight: form.highlight,
    item_date: form.item_date || null,
    internal_note: form.internal_note.trim() || null,
    image_media_id: form.image_media_id,
  };
  if (item) body.id = item.id;
  else body.slug = form.slug.trim();
  return body;
};

const validate = (form, isNew) => {
  if (isNew && !/^[a-z0-9-]+$/.test(form.slug.trim())) return 'Informe um identificador com letras minúsculas, números e hífen.';
  if (!form.title.trim()) return 'Informe o título.';
  const link = form.link.trim();
  if (link && !link.startsWith('/')) return 'O link deve ser uma tela do app, começando com /.';
  return null;
};

/**
 * useItemForm
 *
 * Formulário de uma novidade do catálogo (criar ou editar) e a gravação em item_save.php.
 *
 * @param {Object|null} item - novidade em edição (null = nova)
 * @param {boolean} open - o diálogo está aberto
 */
function useItemForm(item, open) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setForm(item ? formFromItem(item) : EMPTY_FORM);
    setError(null);
  }, [item, open]);

  const setField = useCallback((key, value) => setForm((prev) => ({ ...prev, [key]: value })), []);

  /** onSaved(item) recebe a novidade gravada (ITEM_ADMIN). */
  const save = useCallback((onSaved) => {
    const problem = validate(form, !item);
    if (problem) {
      setError(problem);
      return;
    }
    setIsSaving(true);
    setError(null);
    SaveAdminChangelogItemAPI(bodyFromForm(form, item), (response) => {
      setIsSaving(false);
      if (!response || response.success === false || !response.item) {
        setError(response?.error || 'Não foi possível salvar a novidade.');
        return;
      }
      if (onSaved) onSaved(response.item);
    });
  }, [form, item]);

  return { form, setField, save, isSaving, error };
}

export default useItemForm;
